// src/components/ui/ToastContainer.js
// ============================================================================
// Contenedor global de AVISOS (toasts). Se monta UNA sola vez en App.js.
// ----------------------------------------------------------------------------
// Escucha el singleton `aviso` (src/utils/aviso.js) y pinta los toasts
// apilados abajo-derecha, con entrada/salida animada y auto-cierre. El estilo
// vive en globals.css (bloque "TOASTS") y usa las 4 paletas estándar de banner
// (info / éxito / advertencia / peligro) → tokenizado, claro y oscuro solos.
// ============================================================================
import React, { useState, useEffect, useCallback } from 'react';
import aviso from '../../utils/aviso';
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from './Icons';

const CONFIG = {
  exito:       { Icon: CheckCircleIcon,         clase: 'toast-exito' },
  error:       { Icon: XCircleIcon,             clase: 'toast-error' },
  advertencia: { Icon: ExclamationTriangleIcon, clase: 'toast-advertencia' },
  info:        { Icon: InformationCircleIcon,   clase: 'toast-info' },
};

function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  const cerrar = useCallback((id) => {
    // Marcar como saliendo para disparar la animación de salida; luego desmontar.
    setToasts((prev) => prev.map((t) => (t.id === id ? { ...t, saliendo: true } : t)));
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 280);
  }, []);

  useEffect(() => {
    const desuscribir = aviso._suscribir((toast) => {
      setToasts((prev) => [...prev, toast]);
      if (toast.duracion > 0) {
        setTimeout(() => cerrar(toast.id), toast.duracion);
      }
    });
    return desuscribir;
  }, [cerrar]);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => {
        const cfg = CONFIG[t.tipo] || CONFIG.info;
        const Icon = cfg.Icon;
        return (
          <div
            key={t.id}
            className={`toast ${cfg.clase}${t.saliendo ? ' toast-saliendo' : ''}`}
            role="status"
          >
            <span className="toast-icono"><Icon className="w-5 h-5" /></span>
            <span className="toast-mensaje">{t.mensaje}</span>
            <button
              className="toast-cerrar"
              onClick={() => cerrar(t.id)}
              aria-label="Cerrar aviso"
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default ToastContainer;
